import { defineStore } from 'pinia';
import axios from 'axios';

export const useUserStore = defineStore('user', {
    state: () => ({
        data: null,
        loading: false,
        error: null,
        user: '',
        isAuthorized: false
    }),
    actions: {
        async setUser(date) {
            this.loading = true
            this.error = null
            const userObg = {
                telegramId: date.id ?? '',
                username: date.username ?? '',
                firstName: date.first_name ?? '',
                lastName: date.last_name ?? '',
                avatarUrl: date.photo_url ?? ''
            }
            try {
                const response = await axios.post(
                    '/api/users/setuser',
                    // 'http://localhost:3000/api/users/setuser',
                    userObg,
                    {
                        headers: {
                            'X-API-KEY': process.env.VUE_APP_API_KEY,
                        }
                    }
                )
                this.data = response.data
                this.isAuthorized = true
            } catch (err) {
                this.error = 'Ошибка при получении данныхw'
                this.isAuthorized = false
                console.error(err)
            } finally {
                this.loading = false;
            }
        },

        async useAchievement(telegramId, incType) {
            try {
                const response = await axios.get(
                    '/api/achieved/incrementAchieved',
                    // 'http://localhost:3000/api/achieved/incrementAchieved',
                    {
                        params: {
                            telegram_id: telegramId,
                            incType }, // 1 - тип входа, 2 - расчет цепей
                        headers: {
                            'X-API-KEY': process.env.VUE_APP_API_KEY,
                        }
                    }
                )
                console.log('Increment result:', response.data)
                this.data = response.data
            } catch (error) {
                console.error('Error incrementAchieved:', error)
                // можно дальше пробросить ошибку, чтобы отловить в компоненте
                throw error
            }
        }
    },
    getters: {
        user: (state) => state.user,
        achievements: (state) => state.data?.achieved ?? [],
        hasAchievements: (state) => !!state.data?.exists
    },
});
